import { useEffect } from 'react';
import { logPPIA0002Exposure, usePPIA0002ExperimentEffect } from '../../../utils/experiments/ppia0002';
import { Chat } from '../../utils/chat/Chat';

/**
 * Evaluates the PPIA-0002 experiment and wires up the corner-vs-inline chat
 * widget accordingly:
 *
 * - Control (or ineligible, once the experiment has resolved): load the corner
 *   chat widget and ensure no inline embed is active.
 * - Variant: remove any existing corner widget so `EmbeddedChatWidget` can
 *   mount the inline embed on a page-by-page basis.
 *
 * URL syncing of the cohort param is handled generically by
 * `useSyncInAppTreatmentsToUrl`, so this hook only owns chat-widget behavior
 * and the exposure log.
 *
 * Intended to be called once from the top-level `Routes` component so the
 * corner widget is managed globally, rather than dropping `<ChatLoader />`
 * onto every page.
 */
export const useChatLoader = () => {
  const experiment = usePPIA0002ExperimentEffect();
  const isControl = experiment.isPPIA0002Control;
  const isVariant = experiment.isPPIA0002Variation;
  const isEligible = experiment.isEligibleForPPIA0002;
  const isExperimentLoaded = experiment.isPPIA0002Fetched;
  useEffect(() => {
    if (isEligible) {
      logPPIA0002Exposure();
    }
  }, [isEligible]);
  useEffect(() => {
    if (isControl || !isEligible && isExperimentLoaded) {
      Chat.removeInlineEmbed().remove().load();
    }
    if (isVariant) {
      Chat.remove();
    }
  }, [isEligible, isExperimentLoaded, isControl, isVariant]);
};